import React from "react";
import Skeleton from "react-loading-skeleton";

interface CollectionCardProps {
  title: string;
  imageUrl: string | null;
  imageAlt: string;
  isActive?: boolean;
  onClick: () => void;
}

const CollectionCard: React.FC<CollectionCardProps> = ({
  title,
  imageUrl,
  imageAlt,
  isActive = false,
  onClick,
}) => {
  const placeholderImage = `https://via.placeholder.com/400x500.png/f0f0f0/333333?text=${encodeURIComponent(
    title
  )}`;
  const finalImageUrl = imageUrl || placeholderImage;

  return (
    <div
      className={`collection-card ${isActive ? "is-active" : ""}`}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") onClick();
      }}
    >
      <div className="collection-card__image-wrapper">
        <img
          src={finalImageUrl}
          alt={imageAlt}
          className="collection-card__image"
        />
      </div>
      <div className="collection-card__name">{title}</div>
    </div>
  );
};

const CollectionCardSkeleton: React.FC = () => {
  return (
    <div className="collection-card-skeleton">
      <Skeleton height={250} />
      <Skeleton height={48} style={{ marginTop: "1rem" }} />
    </div>
  );
};

type CollectionCardComponent = React.FC<CollectionCardProps> & {
  Skeleton: React.FC;
};

(CollectionCard as CollectionCardComponent).Skeleton = CollectionCardSkeleton;

export default CollectionCard as CollectionCardComponent;
